import LogoFull from '@/assets/images/logo/logo-green.png';
import { Image } from 'antd';
import './index.scss';

export default function PrivacyPolicy() {
	return (
		<>
			<div
				style={{
					maxWidth: '900px',
					margin: '0 auto',
					marginTop: '50px',
					marginBottom: '50px',
					padding: '0 2rem',
				}}
			>
				<div style={{ marginBottom: '40px' }}>
					<Image src={LogoFull} preview={false} width={200} />
				</div>
				<section className='prose mx-auto my-4 px-[1rem] md:my-8 md:px-0'>
					<h1>
						<strong>Kebijakan Privasi</strong>
					</h1>
					<br />
					<p>
						<strong>&#xFEFF;PENDAHULUAN</strong>
					</p>
					<ul>
						<li>
							Referensi <u> bisnis.vocagame.com</u> dalam Kebijakan Privasi ini dapat berarti{' '}
							bisnis.vocagame.com, afiliasi bisnis.vocagame.com, perusahaan grup, dan anak
							perusahaan bisnis.vocagame.com, termasuk Perwakilan bisnis.vocagame.com, yaitu
							penasihat keuangan, asuransi, hukum, akuntansi, atau penasihat{' '}
							<u> bisnis.vocagame.com</u> lainnya yang menyediakan layanan profesional kepada{' '}
							<u>vocagame</u>
							<a href='https://bisnis.vocagame.com' rel='noopener noreferrer' target='_blank'>
								<u>.</u>
							</a>
							<u>.com</u> dan pihak ketiga yang bekerja sama dengan bisnis.vocagame.com, yakni
							partner, vendor, dan subkontraktor.
						</li>
						<li>
							Kebijakan Privasi ini merupakan bagian tidak terpisahkan dan merupakan satu kesatuan
							dengan Syarat dan Ketentuan <u> bisnis.vocagame.com</u>. Istilah dalam huruf kapital
							yang digunakan dalam Kebijakan Privasi ini memiliki arti yang sama dengan yang
							tercantum dalam Syarat dan Ketentuan
							<u> bisnis.vocagame.com.</u>
						</li>
						<li>
							<u> bisnis.vocagame.com</u> dari waktu ke waktu berhak memperbaharui Kebijakan Privasi
							ini agar tetap relevan dan terkini dengan teknologi yang berubah, hukum yang berlaku,
							praktik bisnis <u> bisnis.vocagame.com </u>yang terus berkembang dan kebutuhan
							pengguna <u> bisnis.vocagame.com</u>. Jika ada perubahan yang dibuat pada Kebijakan
							Privasi ini, <u> bisnis.vocagame.com</u> akan memberikan keterangan “Tanggal
							Pengkinian Terakhir”.
							<u> bisnis.vocagame.com</u> mengimbau kepada Pengguna <u> bisnis.vocagame.com</u>{' '}
							untuk secara berkala meninjau Kebijakan Privasi ini agar tetap mendapat informasi
							tentang bagaimana <u> bisnis.vocagame.com </u>mengelola data dan informasi pribadi
							Anda. Dengan menggunakan Layanan, Pengguna dianggap memberikan persetujuan eksplisit
							atas Kebijakan Privasi dan dengan terus menggunakan Layanan setelah Kebijakan Privasi,
							Pengguna dianggap telah membaca, memahami dan menyetujui Kebijakan Privasi yang
							diperbarui.
						</li>
						<li>
							KEBIJAKAN PRIVASI INI MERUPAKAN BENTUK KESEPAKATAN YANG MERUPAKAN PERJANJIAN MENGIKAT
							ANTARA PENGGUNA DENGAN bisnis.vocagame.com PENGGUNA SECARA SADAR DAN SUKARELA
							MENYETUJUI KETENTUAN INI UNTUK MENGGUNAKAN LAYANAN DI PLATFORM{' '}
							<u> bisnis.vocagame.com</u>
						</li>
					</ul>

					<p>
						<strong>HUKUM DAN PERATURAN YANG BERLAKU</strong>
					</p>
					<br />
					<p>
						{' '}
						bisnis.vocagame.com tunduk terhadap segala peraturan perundang-undangan dan kebijakan
						pemerintah Republik Indonesia yang berlaku, termasuk yang mengatur tentang informasi dan
						transaksi elektronik, penyelenggaraan sistem elektronik, dan perlindungan data pribadi
						Pengguna; termasuk segala peraturan pelaksana dan peraturan perubahan dari
						peraturan-peraturan tersebut yang mengatur dan melindungi penggunaan data dan informasi
						penting para Pengguna.
					</p>
					<br />
					<p>
						<strong>PEROLEHAN DAN PERLINDUNGAN DATA</strong>
					</p>
					<br />
					<p>
						<u> bisnis.vocagame.com</u> berhak meminta data dan informasi Pengguna, antara lain
						sebagai berikut:
					</p>
					<ul>
						<li>
							<strong>Informasi terkait akun bisnis.vocagame.com</strong>
						</li>
					</ul>
					<ol>
						<li>Nama</li>
						<li>Username</li>
						<li>E-mail</li>
						<li>Nomor Telepon</li>
						<li>Alamat dan/atau lokasi</li>
						<li>Profil, antara lain Tanggal Lahir, Jenis kelamin</li>
						<li>Informasi transaksi, keuangan, dan/atau Perbankan</li>
					</ol>
					<ul>
						<li>
							<strong>
								Perilaku Pengguna di <u> bisnis.vocagame.com</u> dan/atau selama menggunakan Layanan
								Informasi pilihan produk, fitur, dan layanan
							</strong>
						</li>
					</ul>
					<ol>
						<li>Informasi preferensi dan minat Pengguna</li>
						<li>Informasi pengalaman Pengguna</li>
						<li>Informasi foto dan media pada perangkat Pengguna</li>
						<li>Informasi scanning QR Code</li>
						<li>Informasi geo location secara real time</li>
						<li>
							Informasi hasil survei yang dikirimkan oleh <u> bisnis.vocagame.com</u> atau atas nama{' '}
							<u> bisnis.vocagame.com</u>
						</li>
						<li>
							Rekam jejak Pengguna (log) yang meliputi namun tidak terbatas pada alamat IP
							perangkat, tanggal, dan waktu akses, fitur aplikasi, lamaan website yang dilihat,
							proses kerja aplikasi dan aktivitas sistem lainnya, jenis web browser, dan/atau situs
							atau situs layanan dari pihak ketiga yang digunakan sebelum berinteraksi dengan situs
						</li>
						<li>
							Informasi lain Pengguna yang meliputi namun tidak terbatas pada aktivitas pendaftaran,
							login, transaksi, dan lain - lain
						</li>
					</ol>
					<ul>
						<li>
							<strong>Informasi yang berasal dari pihak ketiga</strong>
						</li>
					</ul>
					<ol>
						<li>
							Informasi Pribadi yang berasal dari pihak ketiga yang bekerja sama dengan
							<u> bisnis.vocagame.com</u> seperti vendor, agen, penasihat profesional, konsultan,
							dan pihak lain dapat kami kumpulkan sehubungan dengan tujuan dari keterlibatan pihak
							ketiga.
						</li>
						<li>
							<u> bisnis.vocagame.com</u> dapat menerima informasi tentang Pengguna dari Pihak
							Ketiga selama Pihak Ketiga telah memperoleh persetujuan Pengguna untuk memberikan
							informasi yang diperlukan (yang relevan), sebagai contoh informasi pengiriman dan
							alamat dari operator <u> bisnis.vocagame.com</u>, yang
							<u> bisnis.vocagame.com</u> gunakan untuk memperbaiki catatan
							<u> bisnis.vocagame.com</u> dan mengirimkan pembelian berikutnya agar lebih mudah.
						</li>
					</ol>
					<p>
						<br />
					</p>
					<p>
						Dengan memberikan informasi pada huruf a sampai c di atas, Pengguna melepaskan hak atas
						klaim, kerugian, tuntutan, dan gugatan yang mungkin terjadi atas perolehan, penyimpanan,
						penggunaan, pemanfaatan, dan/atau pengungkapan informasi, termasuk informasi pribadi,
						dalam Sistem
						<u> bisnis.vocagame.com</u>.
					</p>
					<ul>
						<li>
							Pengguna dengan ini memberikan persetujuan eksplisit kepada
							<u> bisnis.vocagame.com</u> untuk mendapatkan, mengumpulkan, mengolah, menganalisis,
							menyimpan, menampilkan, menggunakan, memanfaatkan, mempublikasikan, mengirimkan,
							mengungkapkan, menyebarluaskan, menghapus dan memusnahkan data dan informasi pribadi
							yang Pengguna sampaikan (input) ke dalam Sistem <u> bisnis.vocagame.com</u>, termasuk
							data pribadi Pengguna, foto Produk, chat dan percakapan dalam sistem{' '}
							<u> bisnis.vocagame.com</u> dan Pengguna dengan ini menyatakan bahwa pemberian
							persetujuan atas data dan informasi pribadi tersebut dilakukan tanpa paksaan, dalam
							kondisi cakap, dan dengan keadaan sadar, dimana persetujuan tersebut Pengguna berikan
							saat membuat akun <u> bisnis.vocagame.com</u> (“Persetujuan Pengguna”).
						</li>
						<li>
							Atas Persetujuan Pengguna, Pengguna dengan ini menyatakan seluruh data dan informasi
							tersebut adalah milik <u> bisnis.vocagame.com</u>. Untuk menghindari keragu raguan,
							data pribadi Pengguna, baik yang dimasukkan ke dalam Platform{' '}
							<u> bisnis.vocagame.com</u> maupun yang tidak dimasukkan ke dalam Platform{' '}
							<u> bisnis.vocagame.com</u>, adalah milik Pengguna sebagai bagian dari hak pribadi
							secara utuh.
						</li>
						<li>
							Pengguna dengan ini menyatakan data pribadi yang Pengguna sampaikan (input) ke dalam
							Sistem <u> bisnis.vocagame.com</u> (termasuk dokumen yang diunggah dan/atau diberikan
							kepada <u> bisnis.vocagame.com</u>) adalah asli, autentik, benar, akurat, lengkap,
							tidak menyesatkan, terbaru, dan merupakan hak pribadi Pengguna dan/atau dirinya
							berwenang untuk menyampaikan data pribadi Pengguna untuk menyampaikannya ke dalam
							Sistem
							<u> bisnis.vocagame.com</u>.
						</li>
						<li>
							<u> bisnis.vocagame.com</u> melindungi segala informasi yang diberikan Pengguna pada
							saat Pengguna menggunakan seluruh layanan <u> bisnis.vocagame.com</u>, termasuk
							menjaga rahasia, keutuhan, dan ketersediaan data pribadi yang dikelolanya.
						</li>
						<li>
							<u> bisnis.vocagame.com</u> berhak dari waktu ke waktu meminta authentifikasi dan
							pemukhtahiran data pribadi Pengguna, sehingga data dan informasi Pengguna akurat,
							lengkap, dan terbaru, termasuk memberhentikan Layanan sementara dan/atau
							memberhentikan Layanan tetap, dalam hal Pengguna belum melakukan authentifikasi dan
							pemukhtahiran data pribadi Pengguna.
						</li>
						<li>
							Pengguna berhak dari waktu ke waktu melakukan pemukhtahiran data pribadi Pengguna.
						</li>
						<li>
							Pengguna dengan ini memahami bahwa pemanfaatan beberapa fitur tertentu dalam{' '}
							<u> bisnis.vocagame.com</u>
							memerlukan proses authentifikasi data pribadi lebih lanjut dan tunduk pada Aturan
							Penggunaan
							<u> bisnis.vocagame.com</u> serta syarat dan ketentuan fitur tertentu di
							<u> bisnis.vocagame.com</u> tersebut. Pengguna dengan ini menegaskan Persetujuan
							Pengguna adalah persetujuan eksplisit atas perolehan, penyimpanan, penggunaan,
							pemanfaatan, dan/atau pengungkapan data pribadi yang Pengguna sampaikan (input) ke
							dalam Sistem <u> bisnis.vocagame.com</u> dan fitur tertentu di{' '}
							<u> bisnis.vocagame.com</u> tersebut, serta menyatakan bahwa pemberian penggunaan data
							pribadi tersebut dilakukan tanpa paksaan, dalam kondisi cakap, dan dengan keadaan
							sadar.
						</li>
						<li>
							Pengguna membebaskan <u> bisnis.vocagame.com</u> dari segala tuntutan, tuntutan hukum,
							kerugian, dan/atau tuntutan sehubungan dengan kegagalan pemrosesan transaksi pada
							aplikasi <u> bisnis.vocagame.com</u> yang disebabkan oleh
							ketidakakuratan/ketidakcukupan informasi Data Pribadi yang Pengguna berikan kepada{' '}
							<u> bisnis.vocagame.com</u>.
						</li>
					</ul>
					<p>
						<br />
					</p>
					<p>
						<strong>PENGGUNAAN, PENYIMPANAN, PEMANFAATAN, DAN PENGOLAHAN DATA</strong>
					</p>
					<ul>
						<li>
							<u> bisnis.vocagame.com</u> akan mengumpulkan, menggunakan, menyimpan, memanfaatkan,
							mengolah, menganalisa, mengirimkan dan mengungkapkan Data pribadi Pengguna untuk
							tujuan berikut dan tujuan lain yang diizinkan oleh undang-undang dan peraturan yang
							berlaku:
						</li>
					</ul>
					<ol>
						<li>
							Proses Layanan dan transaksi Produk. Dengan tujuan antara lain untuk (i) menerima,
							memproses dan verifikasi pemilihan, pemesanan, pembelian, pembayaran, pengembalian,
							pengalihan, penukaran Produk, (ii) keperluan know-your-customer (“KYC”), (iii)
							pemprosesan data internal (iv) berkomunikasi dengan Pengguna terkait pesanan,
							verifikasi data, produk dan layanan, serta penawaran promosi, (v) monitoring dan
							mengetahui pola transaksi Pengguna, (vi) penagihan, aktivasi, penyediaan,
							pemeliharaan, dukungan, pemecahan masalah, penonaktifan, penggantian, peningkatan atau
							pembaharuan Layanan (vii) keperluan administrasi (viii) memproses segala bentuk
							aktivitas Pengguna yang termasuk namun tidak terbatas pada memproses transaksi,
							verifikasi pembayaran, pengiriman produk, penggunaan layanan, (ix) mengelola atau
							menanggapi pertanyaan Pengguna, (x) menggunakan informasi nama bank yang didalamnya
							termasuk nama dan nomor rekening untuk memastikan pembayaran/penerimaan oleh Pengguna,
							(xi) untuk memenuhi atau memberlakukan pemberitahuan yang berlaku untuk Layanan.
						</li>
						<li>
							Menyediakan, memecahkan masalah, dan meningkatkan Layanan
							<u> bisnis.vocagame.com</u>. <u> bisnis.vocagame.com</u>
							menggunakan Data Pribadi Pengguna untuk (i) menyediakan fungsionalitas, menganalisis
							kinerja, memperbaiki kesalahan, dan meningkatkan kegunaan dan efektivitas Layanan,
							(ii) untuk memastikan Layanan berfungsi secara teknis sebagaimana dimaksud dan untuk
							membantu mengidentifikasi dan memecahkan masalah.
						</li>
						<li>
							Rekomendasi dan personalisasi. <u> bisnis.vocagame.com</u> menggunakan Data Pribadi
							Pengguna untuk merekomendasikan fitur, produk dan layanan yang mungkin menarik bagi
							Pengguna, untuk lebih memahami, menganalisis, dan memprediksi preferensi dan minat
							Pengguna, menggabungkan informasi tersebut dengan informasi lain untuk menyesuaikan
							pengalaman Pengguna, dan mempersonalisasi pengalaman Pengguna dengan Layanan.
						</li>
						<li>
							Menyediakan layanan gambar dan kamera. Saat Pengguna menggunakan layanan gambar dan
							kamera Pengguna, <u> bisnis.vocagame.com</u> menggunakan gambar, video, dan data
							pribadi lainnya untuk menanggapi permintaan Pengguna, memberikan layanan yang diminta
							kepada Pengguna, dan meningkatkan layanan
							<u> bisnis.vocagame.com</u>.
						</li>
						<li>
							Mematuhi kewajiban hukum. Dalam kasus tertentu,
							<u> bisnis.vocagame.com</u> mengumpulkan dan menggunakan Data Pribadi Pengguna untuk
							mematuhi hukum, peraturan dan menanggapi situasi darurat. Misalnya (i){' '}
							<u> bisnis.vocagame.com</u> mengumpulkan dari Pengguna informasi mengenai informasi
							rekening bank untuk verifikasi identitas dan tujuan lainnya, (ii) untuk menanggapi
							perintah pengadilan, somasi atau permintaan yang sah atau proses hukum atau penegakan
							hukum lainnya, (iii) permintaan atau perintah resmi otoritas, aparat atau institusi
							yang berwenang berdasarkan ketentuan hukum yang berlaku, termasuk namun tidak terbatas
							pada perselisihan, penyelidikan, penyidikan, proses hukum dan proses penyelesaian
							sengketa antara <u> bisnis.vocagame.com</u> dengan Pengguna, Pengguna dengan Pengguna
							lain, dan Pengguna dengan pihak lainnya serta kegiatan ilegal lainnya, (iv) permintaan
							institusi perbankan, lembaga keuangan atau lembaga non-keuangan yang berwenang,
							dan/atau pihak ketiga berdasarkan permintaan resmi dan ketentuan hukum yang berlaku,
							(v) untuk memberikan bantuan darurat, keadaan darurat, dalam situasi yang dapat
							mengancam kehidupan, kesehatan atau keselamatan fisik Pengguna atau orang lain.
						</li>
						<li>
							Komunikasi dengan Pengguna. <u> bisnis.vocagame.com</u> menggunakan Data Pribadi
							Pengguna untuk berkomunikasi dengan Pengguna sehubungan dengan Layanan melalui saluran
							yang berbeda (misalnya, melalui telepon, email, obrolan).
						</li>
						<li>
							Periklanan, promosi dan personalisasi. bisnis.vocagame.com menggunakan Data Pribadi
							Pengguna untuk (i) menampilkan atau kegiatan promosi dan iklan berbasis minat untuk
							fitur, produk, dan layanan yang mungkin menarik bagi Pengguna yang meliputi namun
							tidak terbatas pada pengidentifikasi iklan, termasuk yang disediakan oleh platform
							perangkat lunak lain, atau pengenal serupa, untuk memfasilitasi{' '}
							<u> bisnis.vocagame.com</u> dalam melakukan analitik atau penyediaan konten promosi
							atau informasi lain yang mungkin relevan dan menarik bagi Pengguna, (ii) untuk
							memfasilitasi akses Pengguna dan penggunaan Layanan dan/atau penawaran pihak ketiga;
							(iii) untuk mengirim penawaran berlangganan, pesan, berita dan posting dalam Layanan
							atas nama <u> bisnis.vocagame.com</u>.
						</li>
						<li>
							Pencegahan penipuan dan pencucian uang dan risiko kredit.
							<u> bisnis.vocagame.com</u> menggunakan Data Pribadi Pengguna untuk mencegah dan
							mendeteksi penipuan serta pencucian uang dan penyalahgunaan untuk melindungi keamanan
							Pengguna, <u> bisnis.vocagame.com</u>, dan lainnya.
							<u> bisnis.vocagame.com</u> juga dapat menggunakan metode penilaian untuk menilai dan
							mengelola risiko kredit.
						</li>
						<li>
							Mengembangkan Layanan. <u> bisnis.vocagame.com</u> menggunakan Data Pribadi Pengguna
							untuk mengembangkan layanan baru dan meningkatkan Layanan yang ada dan memberikan
							Pengguna informasi tentang konten pihak ketiga atau produk terkait, layanan dan
							perangkat lunak termasuk untuk berkomunikasi dengan Pengguna tentang berbagai cara
							yang mereka gunakan, misalnya untuk menyediakan atau mengirim kepada Pengguna: (i)
							peningkatan atau pembaruan, atau pemberitahuan tentang peningkatan atau pembaruan dari
							Layanan atau konten pihak ketiga atau produk, layanan dan perangkat lunak terkait;
							(ii) pemberitahuan promosi, kontes, penawaran, dan acara mendatang; (iii) informasi
							pribadi, survei, materi pemasaran, iklan atau konten yang disesuaikan. Juga untuk
							tujuan (i) mendeteksi, memantau, menyelidiki, mengurangi atau mencegah penipuan dan
							masalah teknis atau keamanan atau untuk melindungi properti dari{' '}
							<u> bisnis.vocagame.com</u>; (ii) memungkinkan kelangsungan bisnis dan operasi
							pemulihan bencana; (iii) mendapatkan layanan hukum, untuk mencari nasihat hukum
							dan/atau untuk menegakkan hak hukum <u> bisnis.vocagame.com</u> atau hak hukum dari
							anggota lain dari
							<u> bisnis.vocagame.com</u>; (iv) untuk keperluan statistik; (v) pengembangan bisnis,
							produk, mutu, dan pelayanan termasuk kegiatan promosi, studi, riset, dan kerjasama{' '}
							<u> bisnis.vocagame.com</u> dengan pihak ketiga lainnya.
						</li>
						<li>
							Bila diperlukan untuk tujuan yang jelas untuk kepentingan Pengguna dan Persetujuan
							Pengguna tidak dapat diperoleh tepat waktu.
						</li>
						<li>
							Tujuan lain yang disampaikan dari waktu ke waktu oleh
							<u> bisnis.vocagame.com</u> kepada Pengguna, serta diperlukan, diizinkan atau
							diwajibkan oleh hukum dan peraturan yang berlaku.
						</li>
					</ol>
					<ul>
						<li>
							<u> bisnis.vocagame.com</u> dapat bekerja sama dengan perusahaan dan pihak ketiga
							lainnya yang memfasilitasi atau memberikan bantuan dalam pengembangan layanan-layanan
							tertentu untuk dan/atau atas nama <u> bisnis.vocagame.com</u>, meliputi:
						</li>
					</ul>
					<ol>
						<li>Memberikan bantuan Pengguna;</li>
						<li>
							Melaksanakan layanan-layanan terkait dengan Platform (termasuk namun tidak terbatas
							pada layanan pemeliharaan, pengelolaan database, analisis dan penyempurnaan
							fitur-fitur Platform;
						</li>
						<li>
							Untuk membantu penasihat profesional dan auditor eksternal
							<u> bisnis.vocagame.com</u>, termasuk penasihat hukum, penasihat keuangan, dan
							konsultan-konsultan. Para pihak ketiga ini hanya memiliki akses atas Data Pengguna
							untuk melakukan tugas-tugas tersebut untuk dan/atau atas nama
							<u> bisnis.vocagame.com</u> dan secara kontraktual terikat untuk tidak mengungkapkan
							atau menggunakan Informasi Pribadi tersebut untuk tujuan lain apapun.
						</li>
					</ol>
					<ul>
						<li>
							Dalam pengungkapan informasi, <u> bisnis.vocagame.com</u> dapat menginformasikan
							sebagian Data Pengguna sehingga informasi tersebut menjadi informasi yang tidak dapat
							mengidentifikasi Pengguna secara keseluruhan (data agregat/data anonim) yang ditujukan
							untuk pihak ketiga yang digunakan untuk pengembangan Platform, pengelolaan database,
							analisa atau peningkatan Layanan, promosi dan periklanan.
						</li>
						<li>
							<u> bisnis.vocagame.com</u> juga dapat mengkombinasikan Data Pengguna dengan
							informasi-informasi lain sedemikian rupa sehingga informasi tersebut tidak lagi
							terasosiasi dengan Pengguna, kemudian mengungkapkan informasi yang telah
							dikombinasikan tersebut kepada pihak ketiga, untuk tujuan-tujuan seperti pada poin 3.
						</li>
						<li>
							Untuk tujuan pengembangan, peningkatan, penyempurnaan, perlindungan, dan pemeliharaan
							produk dan/atau Layanan Platform,
							<u> bisnis.vocagame.com</u> terkadang diwajibkan untuk mengolah, memanfaatkan,
							menampilkan, mengungkapkan, menerbitkan, mengirimkan, mentransfer, dan/atau
							menyebarluaskan Data Pribadi kepada pihak ketiga. Untuk menghindari keragu-raguan,
							pihak ketiga yang dimaksud dalam ayat ini dapat, termasuk namun tidak terbatas pada:
						</li>
					</ul>
					<ol>
						<li>
							Pihak Ketiga yang berada dalam grup perusahaan, anak perusahaan, afiliasi, partner,
							mitra dan vendor <u> bisnis.vocagame.com</u> untuk atau sehubungan dengan tujuan yang
							berkaitan dengan penyediaan Platform, pengelolaan bisnis, pemberian Layanan,
							pengelolaan data dan kegiatan lainnya;
						</li>
						<li>
							Kepentingan <u> bisnis.vocagame.com</u>, afiliasi <u> bisnis.vocagame.com</u>,
							perusahaan grup dan anak perusahaan <u> bisnis.vocagame.com</u>, untuk pengembangan
							bisnis, produk, mutu, dan pelayanan termasuk kegiatan promosi, studi, riset, dan
							kerjasama <u> bisnis.vocagame.com</u> dengan pihak ketiga lainnya;
						</li>
						<li>
							Kepentingan <u> bisnis.vocagame.com</u> untuk memenuhi tujuan transaksi, antara lain
							dalam hal penjualan semua atau sebagian aset
							<u> bisnis.vocagame.com</u> termasuk setiap pembelian, penjualan, penyewaan, merger
							atau amalgamasi atau akuisisi, pembuangan atau pembiayaan
							<u> bisnis.vocagame.com</u>, afiliasi <u> bisnis.vocagame.com</u>, anak perusahaan
							<u> bisnis.vocagame.com</u> dan perusahaan grup;
						</li>
						<li>
							Pihak Ketiga jika ada transaksi perusahaan, seperti: pembentukan perusahaan patungan,
							restrukturisasi, reorganisasi, penjualan anak perusahaan atau divisi, merger,
							akuisisi, konsolidasi, pengambilalihan, penjualan aset, atau likuidasi;
						</li>
						<li>
							Pihak Ketiga sehubungan dengan penyedia jasa yang dipekerjakan
							<u> bisnis.vocagame.com</u> untuk menjalankan fungsi atas nama
							<u> bisnis.vocagame.com</u>. Contohnya termasuk menghapus informasi berulang dari
							daftar Pengguna, menganalisis data, memberikan bantuan pemasaran, memberikan hasil
							pencarian dan tautan (termasuk daftar dan tautan berbayar), memproses pembayaran,
							mengirimkan konten, penilaian, menilai dan mengelola risiko kredit, dan menyediakan
							layanan Pengguna, jika berlaku. Penyedia layanan pihak ketiga ini memiliki akses ke
							Data Pribadi yang diperlukan untuk menjalankan fungsinya, tetapi tidak boleh
							menggunakannya untuk tujuan lain;
						</li>
						<li>
							Pihak Ketiga lainnya (termasuk agen, vendor, pemasok, kontraktor, pihak ketiga yang
							memberikan layanan kepada <u> bisnis.vocagame.com</u> atau Pengguna, melakukan tugas
							atas nama <u> bisnis.vocagame.com</u> yang mengadakan kerjasama komersial dengan
							bisnis.vocagame.com) untuk atau sehubungan dengan tujuan
							<u> bisnis.vocagame.com</u> yang melibatkan pihak ketiga atau tujuan kerjasama
							<u> bisnis.vocagame.com</u> dengan pihak ketiga (tergantung keadaan), yang mungkin
							termasuk mengizinkan pihak ketiga untuk memperkenalkan atau menawarkan produk atau
							layanan kepada Pengguna atau melakukan kegiatan lain termasuk pemasaran, penelitian,
							analisis dan pengembangan produk pihak ketiga tersebut (tergantung pada keadaan).
						</li>
					</ol>
					<ul>
						<li>
							Sehubungan dengan penerapan widget atau konten dari dalam aplikasi dan/atau Platform{' '}
							<u> bisnis.vocagame.com</u>, <u> bisnis.vocagame.com</u> dengan ini menyatakan bahwa
							pihak ketiga akan dan dapat mengirimkan, menyerahkan dan/atau memberikan Data Pribadi
							Pengguna kepada pihak lain yang bekerjasama dengan pihak ketiga (yang relevan). Dalam
							hal ini, pihak lain yang menerima Data Pribadi Pengguna akan dikenakan kewajiban
							terkait dengan pengiriman dan penggunaan data yang sama yang berlaku untuk pihak
							ketiga <u> bisnis.vocagame.com</u>.
						</li>
						<li>
							<u> bisnis.vocagame.com</u> berhak menyimpan data dan informasi pribadi Pengguna untuk
							memenuhi tujuan Layanan, tujuan Kebijakan Privasi ini, tujuan peraturan
							perundang-undangan dan hukum yang berlaku, termasuk memproses, mentransfer, dan/atau
							menyimpan data dan informasi para Pengguna, baik di dalam wilayah Republik Indonesia
							maupun di luar wilayah Republik Indonesia, dengan memperhatikan regulasi, termasuk
							peraturan perundang-undangan dan kebijakan privasi di negara mana data dan informasi
							para Pengguna diproses, ditransfer, dan/atau disimpan.
						</li>
						<li>
							<u> bisnis.vocagame.com</u> berusaha untuk melindungi keamanan Data Pribadi Pengguna
							selama transmisi dengan menggunakan protokol enkripsi dan perangkat lunak dan{' '}
							<u> bisnis.vocagame.com</u> memastikan bahwa Data Pribadi yang dikumpulkan dan/atau
							dikumpulkan oleh <u> bisnis.vocagame.com</u> akan disimpan dengan aman sesuai dengan
							hukum dan peraturan yang berlaku di Republik Indonesia. Pengguna memahami dan
							menyetujui bahwa <u> bisnis.vocagame.com</u> akan menjaga pengamanan fisik,
							elektronik, dan prosedural sehubungan dengan pengumpulan, penyimpanan, dan
							pengungkapan Data Pribadi Pengguna. Pengguna setuju bahwa <u> bisnis.vocagame.com</u>{' '}
							akan menyimpan Data Pribadi selama diperlukan untuk memenuhi tujuan yang dijelaskan
							dalam Kebijakan Privasi ini.
						</li>
						<li>
							Platform mungkin berisi tautan ke situs pihak ketiga.
							<u> bisnis.vocagame.com</u> tidak bertanggung jawab atas perolehan, pengumpulan,
							pemrosesan, analisis, penggunaan, penyimpanan, penampilan, pengumuman, transmisi,
							penyebaran, penghapusan, dan penghancuran Data Pribadi Pengguna oleh pihak ketiga
							tersebut. Jika Pengguna memberikan informasi langsung ke situs, maka kebijakan privasi
							dan syarat layanan di situs akan berlaku, sehingga segala akibat dari tindakan
							tersebut sepenuhnya menjadi tanggung jawab Pengguna.
						</li>
						<li>
							<u> bisnis.vocagame.com</u>, afiliasi, perusahaan grup, dan anak perusahaan, termasuk
							perwakilan <u> bisnis.vocagame.com</u>, dan pihak ketiga yang bekerja sama dengan{' '}
							<u> bisnis.vocagame.com</u>, dalam menyediakan Layanan berhak memanfaatkan dan
							mengolah data dan informasi pribadi Pengguna untuk memenuhi tujuan Layanan, tujuan
							Kebijakan Privasi ini, tujuan peraturan perundang-undangan dan hukum yang berlaku.
							Pemanfaatan dan pengolahan data tersebut dicakup oleh perjanjian dan memuat klausul
							kerahasiaan yang mengikat para pihak. Dalam hal ini, termasuk perwakilan
							<u> bisnis.vocagame.com</u>.
						</li>
						<li>
							<u> bisnis.vocagame.com</u> dapat memindahkan informasi Data Pribadi Pengguna ke
							platform afiliasi atau penyedia layanan <u> bisnis.vocagame.com</u> atau kepada
							penerima pihak ketiga. Oleh karena itu, dengan menyetujui Kebijakan Privasi ini,
							Pengguna juga memberikan persetujuan untuk memindahkan informasi Data Pribadi ke
							platform afiliasi atau penyedia layanan
							<u> bisnis.vocagame.com</u> atau kepada penerima data pihak ketiga untuk pengembangan
							layanan baik yg bersifat teknis, komersial dan lain lain. Di mana pun informasi Data
							Pribadi Pengguna dipindahkan, disimpan atau diproses oleh <u> bisnis.vocagame.com</u>{' '}
							atau platform afiliasi atau pihak ketiga, atau pihak lain penyedia layanan{' '}
							<u> bisnis.vocagame.com</u>,<u> bisnis.vocagame.com</u> akan mengambil langkah yang
							wajar untuk melindungi privasi Informasi Data Pribadi Pengguna.
						</li>
					</ul>
					<p>&nbsp;</p>
					<p>
						<strong>PENYIMPANAN DATA</strong>
					</p>
					<br />
					<p>
						Data dan informasi Pengguna pada Platform akan disimpan selama masih dipergunakan untuk
						tujuan sebagaimana dimaksud dalam Kebijakan Privasi ini dan sebagaimana diwajibkan
						perundang-undangan yang berlaku.
						<u> bisnis.vocagame.com</u> akan berhenti menyimpan data dan informasi Pengguna segera
						apabila <u> bisnis.vocagame.com</u> menganggap data yang
						<u> bisnis.vocagame.com</u> kumpulkan sudah tidak sesuai dengan tujuan pengumpulan data,
						penyimpanan atas data tersebut tidak lagi diperlukan, tidak diizinkan disimpan atau
						diwajibkan dihapus oleh hukum yang berlaku.
					</p>
					<p>
						<br />
					</p>
					<p>
						<strong>PENGHAPUSAN DATA</strong>
					</p>
					<ol>
						<li>Atas beragam informasi promo terbaru dan penawaran eksklusif, Pengguna dapat:</li>
					</ol>
					<ul>
						<li>
							berhenti berlangganan (unsubscribe) jika tidak ingin menerima informasi tersebut
							melalui klik tautan “berhenti berlangganan” melalui e-mail yang dikirimkan{' '}
							<u> bisnis.vocagame.com</u> kepada Pengguna; atau
						</li>
						<li>
							melakukan pengaturan notifikasi “Promo” pada aplikasi <u> bisnis.vocagame.com</u>.
						</li>
					</ul>
					<ol>
						<li>
							Pengguna dapat menarik Persetujuan Pengguna berikan terkait dengan penggunaan data dan
							informasi pribadi Pengguna, termasuk berhenti menggunakan, mengakses Layanan, dan/atau
							menutup akun dengan memperhatikan ketentuan peraturan perundang-Undangan yang berlaku
							(termasuk ketentuan retensi yang diwajibkan oleh perundang-undangan yang berlaku).
							Pengguna dengan ini menyatakan bahwa Pengguna memahami konsekuensi dari penarikan
							Persetujuan Pengguna, termasuk namun tidak terbatas pada tidak lagi dapat menikmati
							Layanan.
						</li>
						<li>
							Dengan tunduk pada peraturan perundang-undangan yang berlaku, Pengguna dapat
							mengajukan penghapusan data kepada <u> bisnis.vocagame.com</u> melalui Customer
							Service <u> bisnis.vocagame.com</u> dengan melampirkan:
						</li>
					</ol>
					<ul>
						<li>
							formulir permohonan penghapusan data yang telah disediakan oleh
							<u> bisnis.vocagame.com</u>;
						</li>
						<li>
							bukti diri yang sah (KTP/SIM/PASPOR) sesuai dengan identitas pribadinya di halaman
							Akun <u> bisnis.vocagame.com</u>; dan
						</li>
						<li>alasan permintaan penghapusan.</li>
					</ul>
					<ol>
						<li>
							Pengguna wajib terlebih dahulu mempelajari dan menyetujui Syarat dan Ketentuan
							Penghapusan Akun.
						</li>
						<li>
							<u> bisnis.vocagame.com</u> menyetujui penghapusan data yang diajukan oleh Pengguna
							jika telah memenuhi ketentuan pada angka 3 di atas dan telah memenuhi hak dan
							kewajibannya di <u> bisnis.vocagame.com</u> dalam waktu yang wajar.
						</li>
						<li>
							<u> bisnis.vocagame.com</u> atas permintaan Pengguna dapat mengumpulkan data dan
							informasi Pengguna dibuat tidak dikenali.
						</li>
						<li>
							<u> bisnis.vocagame.com</u> berhak untuk tetap menyimpan data Pengguna selama masa
							retensi yang telah ditetapkan oleh <u> bisnis.vocagame.com</u> pada sistem
							<u> bisnis.vocagame.com</u> sesuai perundang-undangan.
						</li>
						<li>
							<u> bisnis.vocagame.com</u> berhak menolak permintaan Pengguna untuk mengakses
							dan/atau mengubah atau menghapus Data Pribadi Pengguna dengan alasan yang dibenarkan
							berdasarkan peraturan perundang-undangan yang berlaku.
						</li>
						<li>
							Penghapusan data dan penyimpanan data akan dilakukan oleh
							<u> bisnis.vocagame.com</u> sesuai dengan ketentuan peraturan perundang-undangan yang
							berlaku.
						</li>
					</ol>
					<p>&nbsp;</p>
					<p>
						<strong>PEMBATASAN TANGGUNG JAWAB bisnis.vocagame.com</strong>
					</p>
					<ol>
						<li>
							Pengguna bertanggung jawab atas keamanan dan mitigasi pelanggaran atas Akun{' '}
							<u>Vovagame.com</u> Pengguna sendiri, seperti menjaga kerahasiaan Data Pribadi
							Pengguna, menerapkan pengamanan yang tepat, membatasi akses, membuat kata sandi
							dan/atau PIN (personal identification number) yang kuat, menjaga kata sandi dan/atau
							PIN yang Pengguna buat dan gunakan untuk mengakses Data Pribadi Pengguna dimanapun
							Pengguna menyimpan Data Pribadi, menjaga one time password (“OTP”).
						</li>
						<li>
							Pengguna bertanggung jawab atas semua penyalahgunaan kata sandi dan/atau PIN (baik
							yang dilakukan oleh Pengguna dan/atau pihak ketiga) atau penyalahgunaan Platform, yang
							dibuat dan digunakan oleh Pengguna atau pihak ketiga yang mendapatkan kata pada
							Platform dan/atau platform pihak ketiga yang berafiliasi dengan Pengguna untuk
							mengakses Data Pribadi Pengguna termasuk Akun, kata sandi dan/atau PIN untuk mengakses
							atau login ke aplikasi milik Pengguna yang dilakukan oleh pihak selain Pengguna dan
							penyalahgunaan tersebut bukan merupakan tanggung jawab
							<u> bisnis.vocagame.com</u>.
						</li>
						<li>
							Pengguna wajib segera memberitahukan kepada <u> bisnis.vocagame.com</u> apabila
							Pengguna meyakini bahwa kata sandi dan/atau PIN Platform
							<u> bisnis.vocagame.com</u> dan/atau platform pihak ketiga yang berafiliasi dengan
							<u> bisnis.vocagame.com</u> untuk mengakses Platform disalah-gunakan oleh pihak lain
							yang tidak bertanggung jawab dan/atau berwenang.
						</li>
						<li>
							<u> bisnis.vocagame.com</u> tidak bertanggung jawab atas pertukaran dan pemberian data
							dan informasi pribadi Pengguna yang dilakukan sendiri oleh Pengguna, termasuk yang
							dilakukan antar-Pengguna. Termasuk dalam ketentuan ini adalah setiap dan segala
							kesalahan Pengguna yang mengakibatkan kebocoran data Pengguna.
						</li>
						<li>
							<u> bisnis.vocagame.com</u> bertanggung jawab atas Platform{' '}
							<u> bisnis.vocagame.com</u>, termasuk perlindungan serta pengamanan rahasia data
							pribadi, termasuk memberitahukan Pengguna dalam hal terjadi kegagalan dalam
							perlindungan data pribadi melalui sekurang-kurangnya melalui e-mail Pengguna yang
							terdaftar pada Platform <u> bisnis.vocagame.com</u> dan melaporkan kepada aparat
							penegak hukum atau otoritas terkait. Dalam hal terjadi kebocoran data, pihak yang
							bertanggung jawab untuk menginformasikan kepada Pengguna terkait kegagalan dalam
							perlindungan data tersebut adalah pihak atau institusi dimana data tersebut diproses
							berdasarkan Kebijakan Privasi ini.
						</li>
						<li>
							<u> bisnis.vocagame.com</u> tidak bertanggung jawab atas keaslian, keautentikan,
							kebenaran, keakuratan, kelengkapan data pribadi yang dimasukkan oleh Pengguna ke dalam
							Platform <u> bisnis.vocagame.com</u>.
						</li>
						<li>
							Dengan memberikan Persetujuan Pengguna, Pengguna melepaskan hak atas klaim, kerugian,
							tuntutan dan gugatan yang mungkin terjadi atas perolehan, penyimpanan, penggunaan,
							pemanfaatan dan/atau pengungkapan data, termasuk data pribadi, dalam Platform{' '}
							<u> bisnis.vocagame.com</u>.
						</li>
						<li>
							Dalam hal Pengguna adalah anak belum dewasa, <u> bisnis.vocagame.com</u> tidak
							bertanggung jawab atas input data pribadi Pengguna dan menganjurkan agar orang
							tua/wali anak memantau penggunaan internet anak, sehingga pemberian data pribadi
							Pengguna diberikan dan/atau dalam pengawasan orang tua/wali sebagai pihak yang
							berwenang.
						</li>
						<li>
							<u> bisnis.vocagame.com</u> tidak dapat diminta pertanggungjawabannya atas kebocoran
							data yang diakibatkan oleh suatu sebab yang berada di luar kemampuan atau kekuasaan{' '}
							<u> bisnis.vocagame.com</u> (Keadaan Memaksa). Yang dimaksud dengan Keadaan Memaksa
							meliputi namun tidak terbatas pada antara lain (i) pemogokan kerja masal, penutupan
							perusahaan, dan aksi industrial lain; (ii) huru-hara, demonstrasi, kerusuhan, invasi,
							perebutan kekuasaan, sabotase, embargo, perubahan drastis politik/ekonomi, serangan
							atau ancaman teroris, perang (baik yang dinyatakan atau tidak) atau ancaman persiapan
							perang; (iii) gempa bumi, angin puyuh, tanah longsor, banjir, kebakaran, ledakan,
							badai, bencana alam lainnya, wabah yang bersifat epidemi atau pandemi yang dikuatkan
							ataupun tidak oleh pernyataan dari pihak yang berwenang dalam hal itu, serta
							diundangkannya peraturan perundang-undangan baru yang secara langsung atau tidak
							langsung mempengaruhi pelaksanaan Kebijakan Privasi, yang mengakibatkan tidak dapat
							dilaksanakannya kewajiban suatu pihak dalam Kebijakan Privasi ini; (iv) tidak
							tersedianya atau terganggunya penggunaan jaringan pengiriman barang (termasuk jalur
							transportasi); (v) tidak tersedianya atau terganggunya jaringan telekomunikasi, sistem
							informasi dan teknologi, matinya atau tidak tersedianya jaringan internet yang
							bersifat luas, atau tersambar petir; (vi) terdapatnya kegagalan sistem yang
							diakibatkan pihak ketiga yang terjadi di luar wewenang <u> bisnis.vocagame.com</u>{' '}
							(contoh: peretasan (hacking) sistem oleh pihak ketiga dan/atau virus); (vii) tidak
							berfungsinya sistem dan/atau jaringan perbankan; (viii) tindakan, putusan,
							undang-undang, peraturan atau pembatasan yang diterbitkan pemerintah terkait
							pelaksanaan Kebijakan Privasi; dan (ix) perubahan terhadap kondisi di bidang ekonomi
							dan keuangan, serta pembatasan yang dilakukan otoritas regulator terkait penggunaan
							Kebijakan Privasi.
						</li>
					</ol>
					<p>&nbsp;</p>
					<p>
						<strong>COOKIES</strong>
					</p>
					<ul>
						<li>
							Cookies adalah tempat penyimpanan data yang kecil terdapat pada komputer atau
							perangkat lain seperti ponsel pintar atau tablet, pada saat Pengguna menelusuri
							dan/atau mengunjungi<u> bisnis.vocagame.com</u>.
						</li>
						<li>
							Komputer atau perangkat lain Pengguna akan secara otomatis menerima Cookies pada saat
							Pengguna menelusuri dan/atau mengunjungi Platform
							<u> bisnis.vocagame.com</u> serta saat Pengguna menggunakan layanan
							<u> bisnis.vocagame.com</u> (Penggunaan Cookies). Namun, Pengguna dapat menentukan
							pilihan untuk melakukan modifikasi atau memilih untuk menolak Penggunaan Cookies
							melalui preferensi pengaturan web browser Pengguna.
						</li>
						<li>
							<u> bisnis.vocagame.com</u> menggunakan Google Analytics (Fitur), dimana data yang
							diperoleh dari penggunaan Fitur tersebut meliputi, IP address Pengguna, jenis
							perangkat Pengguna, dan lain – lain (Data). Data tersebut digunakan oleh{' '}
							<u> bisnis.vocagame.com</u> untuk pengembangan Platform dan Konten
							<u> bisnis.vocagame.com</u> serta pengiklanan. Pengguna dapat memilih untuk tidak
							terakses oleh Fitur dilakukan dengan cara mengunduh Google Analytics Opt-Out Add-on
							pada web browser Pengguna.
						</li>
						<li>
							<u> bisnis.vocagame.com</u> dapat memberikan data dan informasi Pengguna yang berasal
							dari dari Penggunaan Cookies kepada pihak ketiga, seperti data lokasi,
							pengidentifikasi iklan, atau alamat email yang digunakan untuk segmentasi periklanan,
							termasuk namun tidak terbatas pada untuk kebutuhan pemasaran dan periklanan, dimana
							data dan informasi tersebut tidak dapat diidentifikasi secara pribadi.
						</li>
						<li>
							Pengguna dapat melakukan kontrol terhadap Penggunaan Cookies melalui preferensi
							pengaturan web browser Pengguna yaitu dengan modifikasi atau memilih untuk menolak
							Penggunaan Cookies. Namun dengan melakukan pengaturan tersebut, kinerja pelayanan pada
							saat akses ke Platform
							<u> bisnis.vocagame.com</u> dapat terpengaruh, seperti fungsi dan halaman tertentu
							pada Platform <u> bisnis.vocagame.com</u> tidak dapat bekerja optimal untuk layanan
							kepada Pengguna.
						</li>
					</ul>
					<p>&nbsp;</p>
					<p>
						<strong>HAK KEKAYAAN INTELEKTUAL</strong>
					</p>
					<ul>
						<li>
							Semua karya yang terdapat pada Layanan atau Platform dan sistem pendukungnya termasuk
							namun tidak terbatas pada: (a) tata letak, desain dan tampilan Layanan atau Platform
							yang terdapat atau ditampilkan pada media <u> bisnis.vocagame.com</u>; (b) logo, foto,
							gambar, nama, merek, kata, huruf, angka, tulisan, dan susunan warna yang terdapat pada
							Layanan atau Platform; dan (c) gabungan unsur-unsur sebagaimana dimaksud dalam huruf
							(a) dan (b), sepenuhnya merupakan Hak atas Kekayaan Intelektual
							<u> bisnis.vocagame.com</u> dan tidak ada pihak lain yang juga memiliki hak atas
							Layanan atau Platform <u> bisnis.vocagame.com</u>.
						</li>
						<li>Pengguna tidak diperbolehkan dari waktu ke waktu untuk:</li>
					</ul>
					<ol>
						<li>
							menyalin, memodifikasi, mengadaptasi, menerjemahkan, membuat karya turunan dari,
							mendistribusikan, menjual, mentransfer, menampilkan kepada publik, memperbanyak,
							mentransmisikan, mentransfer, menyiarkan, mendeskripsikan, atau membongkar bagian mana
							pun dari atau dengan cara lain mengeksploitasi Platform (termasuk sistem pendukung dan
							fasilitas di dalamnya) yang dilisensikan kepada Pengguna, kecuali sebagaimana
							diizinkan dalam Kebijakan Privasi ini;
						</li>
						<li>
							melisensikan, mensublisensikan, menjual, menjual kembali, mentransfer, mentransfer,
							mendistribusikan atau mengeksploitasi secara komersial atau dengan cara lain
							menyediakan perangkat lunak dan/atau perangkat lunak kepada pihak ketiga dengan cara
							apa pun;
						</li>
						<li>
							mempublikasikan, mendistribusikan atau mereproduksi dengan cara apapun materi berhak
							cipta, merek dagang, atau informasi lain dari
							<u> bisnis.vocagame.com</u> tanpa memperoleh persetujuan sebelumnya dari hak milik
							<u> bisnis.vocagame.com</u> atau pemilik hak yang melisensikan haknya kepada
							<u> bisnis.vocagame.com</u>;
						</li>
						<li>
							menghapus hak cipta, merek dagang, atau pemberitahuan kepemilikan lainnya yang
							terkandung dalam layanan <u> bisnis.vocagame.com</u>;
						</li>
						<li>
							merekayasa ulang aplikasi <u> bisnis.vocagame.com</u> atau akses dan/atau sistem
							pendukung untuk (i) membangun counter produk atau layanan, (ii) membangun produk atau
							layanan menggunakan ide, fitur, fungsi atau grafik yang serupa, atau (iii) salinan
							ide, fitur , fungsi atau grafik;
						</li>
						<li>
							meluncurkan program atau skrip otomatis, termasuk, tetapi tidak terbatas pada, perayap
							web, robot web, pengindeks web, bot, virus, worm, atau aplikasi serupa lainnya dan
							program apa pun yang dapat membuat beberapa permintaan server per detik, membuat beban
							berat, atau menghambat operasi dan/atau kinerja Platform;
						</li>
						<li>
							menggunakan robot, spider, aplikasi pencarian / pengambilan situs lagi, atau manual
							atau otomatis lainnya atau proses untuk mengambil, mengindeks, "penambangan data"
							(data mine), atau dengan cara apapun mereproduksi atau menghindari struktur navigasi
							atau presentasi aplikasi
							<u> bisnis.vocagame.com</u> dan isinya.
						</li>
					</ol>
					<p>&nbsp;</p>
					<p>
						<strong>PERUBAHAN ATAS KEBIJAKAN PRIVASI</strong>
					</p>
					<br />
					<p>
						<u> bisnis.vocagame.com</u> memiliki hak untuk melakukan pembaruan dan/atau perubahan
						Kebijakan Privasi dari waktu ke waktu jika diperlukan demi keamanan dan kenyamanan
						transaksi Pengguna di Platform
						<u> bisnis.vocagame.com</u> tanpa pemberitahuan sebelumnya. Pengguna dengan ini setuju
						bahwa Pengguna bertanggung jawab untuk membaca secara seksama dan memeriksa Kebijakan
						Privasi ini dari waktu ke waktu untuk mengetahui pembaruan dan/atau perubahan apapun.
						Dengan tetap mengakses dan menggunakan layanan di Platform <u> bisnis.vocagame.com</u>,
						maka Pengguna dianggap menyetujui pembaruan dan/atau perubahan dalam Kebijakan Privasi
						ini.
					</p>
				</section>
			</div>
		</>
	);
}
